<template>
    <div class="kleptos-user-level unselectable">
        <span class="text">{{ userLevel }}</span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters('player', [
                'userLevel'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    .kleptos-user-level {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 0 30px;
        width: rem-calc(47); //47px;
        height: rem-calc(54); //54px;
        // background: url(../../../assets/img/dock-user-level-bg@2x.png) no-repeat center center;
        background: url(../../../assets/img/dockUserLevelSprite@2x.png) no-repeat top;
        background-size: 100%;
        // background-size: 47px;
        // background-size: contain;
        font-size: rem-calc(21);//21px;
        font-family: 'Helvetica Neue';
        font-family: 'Great Lakes';
        font-weight: normal;
        color: #cb569e;

        .text {
            // margin-top: -1px; // fix tiny visual inconsistency

            &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url(../../../assets/img/dockUserLevelSprite@2x.png) no-repeat bottom;
                background-size: 100%;
                // opacity: 0.9;
            }
        }
    }

    // make this global
    .unselectable {
        cursor: default;
        -webkit-user-select: none !important; /* Safari */
        -moz-user-select: none !important; /* Firefox */
        -ms-user-select: none !important; /* IE10+/Edge */
        user-select: none !important; /* Standard */
    }
</style>